import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";

export const left = (props) => {
  return <ChevronLeftRoundedIcon {...props} />;
};
